var _rect, _rect2, _g, _g2, _g3, _g4, _g5, _g6, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 480,
    viewBox: "0 0 960 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_7)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 480,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_7)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 540,
    transform: "translate(0 -30)",
    fill: "url(#paint0_linear_1_7)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bf_1_7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 353.474,
    cy: 217.089,
    rx: 353.474,
    ry: 217.089,
    transform: "matrix(0.838628 -0.544705 0.456584 0.88968 494.354 126.192)",
    fill: "#F178B6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bf_1_7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 362.705,
    cy: 224.176,
    rx: 362.705,
    ry: 224.176,
    transform: "matrix(0.930953 -0.365138 0.296013 0.955184 -225.296 362.898)",
    fill: "#9B68DE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bf_1_7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 408.235,
    cy: 108.057,
    rx: 408.235,
    ry: 108.057,
    transform: "matrix(0.986796 -0.161967 0.128609 0.991695 371.644 201.212)",
    fill: "#DC3618"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bf_1_7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.849,
    cy: 72.8155,
    rx: 283.849,
    ry: 72.8155,
    transform: "matrix(0.984022 0.178047 -0.141524 0.989935 184.784 213.017)",
    fill: "#F58AB9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bf_1_7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.53,
    cy: 572.488,
    rx: 247.116,
    ry: 278.006,
    fill: "#F8A0D1"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_bf_1_7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.849,
    cy: 99.3054,
    rx: 283.849,
    ry: 99.3054,
    transform: "matrix(0.984022 0.178047 -0.141524 0.989935 584.818 260.348)",
    fill: "#9B68DE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -23,
    y: -81.75,
    width: 1006,
    height: 642.375,
    fill: "#FCDDEC"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bf_1_7",
    x: 457.256,
    y: -265.923,
    width: 865.301,
    height: 785.433,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_7",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect2_foregroundBlur_1_7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bf_1_7",
    x: -285.461,
    y: 72.7789,
    width: 928.371,
    height: 743.62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_7",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect2_foregroundBlur_1_7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bf_1_7",
    x: 265.297,
    y: -3.68379,
    width: 1046.18,
    height: 491.869,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_7",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect2_foregroundBlur_1_7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bf_1_7",
    x: 134.285,
    y: 207.596,
    width: 639.015,
    height: 256.083,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_7",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect2_foregroundBlur_1_7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bf_1_7",
    x: -57.5864,
    y: 174.482,
    width: 734.233,
    height: 796.012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_7",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect2_foregroundBlur_1_7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_bf_1_7",
    x: 450.404,
    y: 178.634,
    width: 799.347,
    height: 461.118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_7",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect2_foregroundBlur_1_7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_7",
    x1: 480,
    y1: 0,
    x2: 480,
    y2: 540,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A643F4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 480,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 540,
    fill: "white",
    transform: "translate(0 -30)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.b1f7a19b314252d18d4e1eed5bfd4880.svg";
export { ForwardRef as ReactComponent };